import { catTexts } from './langs/cat';
import { dutTexts } from './langs/dut';
import { engTexts } from './langs/eng';
import { eskTexts } from './langs/esk';
import { gerTexts } from './langs/ger';
import { glgTexts } from './langs/glg';
import { porTexts } from './langs/por';
import { spaTexts } from './langs/spa';
import { freTexts } from './langs/fre';
import { itaTexts } from './langs/ita';
import { type Language, languages } from '@/shared';

export const GenericTexts = {
	[languages.Spanish]: spaTexts,
	[languages.Euskera]: eskTexts,
	[languages.Gallego]: glgTexts,
	[languages.English]: engTexts,
	[languages.Catalan]: catTexts,
	[languages.Portuguese]: porTexts,
	[languages.French]: freTexts,
	[languages.Italian]: itaTexts,
	[languages.Dutch]: dutTexts,
	[languages.German]: gerTexts,
	[languages.Korean]: engTexts,
	[languages.Chinese]: engTexts,
	[languages.Japanese]: engTexts,
	[languages.Russian]: engTexts,
	[languages.Greek]: engTexts,
} satisfies Record<Language, unknown>;
